import React from "react";
import { LoadingDialog } from "../../../../../../_metronic/partials/control";

export interface PurchasesLoadingDialogProps {
  color?: string
}
export const PurchasesLoadingDialog: React.FC<PurchasesLoadingDialogProps> = ({color}) => {
  return <LoadingDialog color={color} text="Cargando ..." />;
}



